import React from 'react'

import { IconComponent } from '@application/Interfaces/Icons/types'

export const ComputerIcon: IconComponent = ({ className, width = 86, height = 86 }) => {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 86 86"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_37856_93537)">
                <path
                    d="M81.5517 0.463379H4.44828C1.99246 0.463379 0 2.45584 0 4.91166V64.4073C0 66.8632 1.99246 68.8556 4.44828 68.8556H35.9569L32.4391 81.8149C39.515 80.8245 46.8036 80.8626 53.7 81.8353L50.0431 68.8556H81.5517C84.0075 68.8556 86 66.8632 86 64.4073V4.91166C86 2.45584 84.0075 0.463379 81.5517 0.463379Z"
                    fill="#4B95CB"
                />
                <path
                    d="M86 4.91166V59.5884H0V4.91166C0 2.45584 1.99246 0.463379 4.44828 0.463379H81.5517C84.0075 0.463379 86 2.45584 86 4.91166Z"
                    fill="#F99727"
                />
                <path
                    d="M86 4.91166C86 7.57302 83.8424 9.73062 81.181 9.73062H59.8664C31.9212 9.73062 9.26724 36.0915 9.26724 64.0367C9.26724 66.698 7.10964 68.8556 4.44828 68.8556C1.99153 68.8556 0 66.8641 0 64.4073V4.91166C0 2.45491 1.99153 0.463379 4.44828 0.463379H81.5517C84.0085 0.463379 86 2.45491 86 4.91166Z"
                    fill="#F5AB56"
                />
                <path
                    d="M20.825 84.4936C20.582 83.7115 21.019 82.8806 21.801 82.6378C35.0465 78.5227 51.466 78.6792 64.1985 82.6378C64.9804 82.8809 65.4173 83.7118 65.1741 84.4938C64.931 85.2758 64.1001 85.713 63.3181 85.4695C50.9389 81.6208 35.1236 81.6041 22.681 85.4695C21.9005 85.7123 21.0683 85.2771 20.825 84.4936Z"
                    fill="#146FB7"
                />
                <path d="M51.6103 74.4158H34.4492L35.9579 68.8555H50.0441L51.6103 74.4158Z" fill="#004475" />
                <path
                    d="M86 59.5884V64.4073C86 66.8632 84.0075 68.8556 81.5517 68.8556H4.44828C1.99246 68.8556 0 66.8632 0 64.4073V59.5884H86Z"
                    fill="#146FB7"
                />
                <path
                    d="M9.45815 59.5884C9.33211 61.0637 9.26724 62.5483 9.26724 64.0366C9.26724 66.6982 7.10983 68.8556 4.44828 68.8556C1.99246 68.8556 0 66.8632 0 64.4073V59.5884H9.45815Z"
                    fill="#4B95CB"
                />
                <path
                    d="M33.6044 28.2625C34.1838 28.8417 35.1222 28.8415 35.7014 28.2625C36.2804 27.6835 36.2804 26.7447 35.7014 26.1657L33.8463 24.3106L35.7016 22.4553C36.2806 21.8761 36.2802 20.9373 35.701 20.3583C35.1218 19.7795 34.183 19.7797 33.6042 20.3589L31.7495 22.2136L29.8945 20.3587C29.3153 19.7797 28.3767 19.7797 27.7975 20.3587C27.2185 20.9377 27.2185 21.8765 27.7975 22.4555L29.6525 24.3104L27.7979 26.165C27.2187 26.744 27.2183 27.6826 27.7974 28.262C28.376 28.841 29.315 28.8415 29.8942 28.2625L31.7495 26.4072L33.6044 28.2625Z"
                    fill="white"
                />
                <path
                    d="M58.1991 26.1657L56.3439 24.3106L58.1992 22.4553C58.7783 21.8761 58.7779 20.9373 58.1987 20.3583C57.6193 19.7795 56.6805 19.7797 56.1019 20.3589L54.2471 22.2136L52.3922 20.3587C51.813 19.7797 50.8744 19.7797 50.2952 20.3587C49.7162 20.9377 49.7162 21.8765 50.2952 22.4555L52.1501 24.3104L50.2956 26.165C49.3583 27.1019 50.0348 28.6966 51.3437 28.6966C51.7231 28.6966 52.1025 28.5518 52.3918 28.2627L54.2471 26.4074L56.1021 28.2623C56.3918 28.5518 56.771 28.6966 57.1506 28.6966C58.4591 28.697 59.1364 27.1032 58.1991 26.1657Z"
                    fill="white"
                />
                <path
                    d="M30.7138 43.3316C30.1294 43.9051 30.1203 44.8438 30.6938 45.4284C31.2654 46.0113 32.2042 46.0237 32.7906 45.4486C33.7883 44.4698 37.4737 41.2763 43.0009 41.2763C44.3984 41.2763 49.2646 41.5773 53.2111 45.4486C53.7955 46.0219 54.7345 46.0134 55.3079 45.4284C55.8814 44.8438 55.8723 43.9051 55.2879 43.3316C48.6229 36.7937 37.6746 36.5037 30.7138 43.3316Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_37856_93537">
                    <rect width={width} height={height} fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
